import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubject,
  updateExamSubject,
  getExamSubject,
} from "../../store/slices/subject";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";


export default function EditExamSubject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [standardId, setStandardId] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [errors, setErrors] = useState({});

  /* ---------- FETCH DATA ---------- */
  useEffect(() => {
    dispatch(getSubject());

    if (id) {

      dispatch(getExamSubject({ id }));
    }
  }, [dispatch, id]);

  /* ---------- REDUX ---------- */
  const {
    subjectlist = [],
    examsubjectlist = [],
    loading,
  } = useSelector((state) => state.subject || {});

  /* ---------- PREFILL EDIT DATA ---------- */
  useEffect(() => {
    if (Array.isArray(examsubjectlist) && examsubjectlist.length > 0) {
      const record = examsubjectlist[0];

      // set standard
      setStandardId(record?.standardId?._id || "");

      // remove duplicate subjects safely
      const uniqueSubjectIds = [
        ...new Set((record?.subjectId || []).map((s) => s._id)),
      ];

      setSelectedSubjects(uniqueSubjectIds);
    }
  }, [examsubjectlist]);

  /* ---------- CHECKBOX ---------- */
  const handleCheckboxChange = (subId) => {
    setSelectedSubjects((prev) =>
      prev.includes(subId)
        ? prev.filter((id) => id !== subId)
        : [...prev, subId]
    );
  };

  /* ---------- VALIDATION ---------- */
  const validate = () => {
    const newErrors = {};

    if (!standardId) {
      newErrors.standardId = "Standard not found";
    }

    if (selectedSubjects.length === 0) {
      newErrors.subjects = "Please select at least one subject";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---------- SUBMIT ---------- */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = {
      id,
      standardId,
      subjectId: selectedSubjects,
    };

    dispatch(updateExamSubject(payload))
      .unwrap()
      .then(() => {
        toast.success("Subjects updated successfully");
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err || "Failed to update subjects");
      });
  };

  return (
    <>
      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />
            <Link to="/institute/examsubjects">Exam Subjects</Link>

            <FiChevronRight className="separator" />

            <span className="active">Edit Exam Subject</span>
          </div>


        </div>

      </div>


      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {/* ---------- STANDARD (READ ONLY) ---------- */}
            <Col md={3} sm={12}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>
                <Form.Control
                  type="text"
                  value={
                    examsubjectlist.length
                      ? examsubjectlist[0].standardId?.name
                      : ""
                  }
                  disabled
                />
              </Form.Group>
            </Col>

            {/* ---------- SUBJECTS ---------- */}
            <Col md={12}>
              <Form.Group>
                <Form.Label>Subjects</Form.Label>

                <div className="sa-checkbox-grid">
                  {subjectlist.map((sub) => (
                    <label key={sub._id} className="sa-checkbox-item">
                      <input
                        type="checkbox"
                        checked={selectedSubjects.includes(sub._id)}
                        onChange={() => handleCheckboxChange(sub._id)}
                      />
                      <span>{sub.name}</span>
                    </label>
                  ))}
                </div>

                {errors.subjects && (
                  <small className="text-danger">{errors.subjects}</small>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* ---------- ACTIONS ---------- */}
          <div className="sa-actions mt-5">
            <button
              type="button"
              className="btn-cancel"

              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button type="submit" className="btn-submit">
              Update
            </button>
          </div>
        </Form>
      </div >
    </>
  );
}
